import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import DataTable from "react-data-table-component";

const ManageBalanceTable = ({
  unpaginate_manage_balance,
  updateManageBalance,
}) => {
  const [search, setSearch] = useState("");
  const [filterManageBalance, setFilterManageBalance] = useState("");

  const colums = [
    {
      name: "ID",
      selector: (row) => row.id,
      sortable: true,
    },
    {
      name: "Name",
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: "Status",
      selector: (row) => row.acc_status,
      cell: (row) => (row.acc_status ? "Active" : "Inactive"),
    },
    {
      name: "Account Type",
      selector: (row) => row.acc_type,
      sortable: true,
    },
    {
      name: "Account Number",
      selector: (row) => row.acc_number,
      sortable: true,
    },
    {
      name: "Action",
      selector: (row) => (
        <ul className="d-flex gap-2 list-unstyled mb-0">
          <li>
            <Link
              to="#ManageBalanceUpdateModal"
              data-bs-toggle="modal"
              className="btn btn-subtle-secondary btn-icon btn-sm edit-item-btn"
              onClick={() => updateManageBalance(row.id)}
            >
              <i className="ph-pencil"></i>
            </Link>
          </li>
          <li>
            <Link
              to="#ManageBalanceDeleteModal"
              data-bs-toggle="modal"
              className="btn btn-subtle-danger btn-icon btn-sm remove-item-btn"
            >
              <i className="ph-trash"></i>
            </Link>
          </li>
        </ul>
      ),
    },
  ];

  useEffect(() => {
    const result =
      unpaginate_manage_balance &&
      unpaginate_manage_balance.filter((data) => {
        const nameMatch = data.name
          .toLowerCase()
          .includes(search.toLowerCase());
        const idMatch = String(data.id).includes(search.toLowerCase());
        return nameMatch || idMatch;
      });
    setFilterManageBalance(result);
  }, [search, unpaginate_manage_balance]);

  return (
    <DataTable
      columns={colums}
      data={filterManageBalance}
      pagination
      fixedHeader
      fixedHeaderScrollHeight="450px"
      selectableRows
      selectableRowsHighlight
      highlightOnHover
      subHeader
      subHeaderAlign="left"
      subHeaderComponent={
        <input
          type="text"
          placeholder="Search here"
          className="w-100 form-control"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        ></input>
      }
    />
  );
};

export default ManageBalanceTable;
